var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import React, { useEffect, useMemo, useState } from 'react';
import styled, { css } from 'styled-components';
import { lighten, desaturate, darken } from 'polished';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import { SAInput } from '../input/input.component';
import { SAUX360Theme } from '../theme';
import { SAIcons } from '../icon';
export var SAHighlighter = function (_a) {
    var children = _a.children, highlight = _a.highlight, className = _a.className;
    if (!highlight)
        return children;
    var regexp = new RegExp(highlight, 'gi');
    var matches = children.match(regexp);
    var parts = children.split(new RegExp("" + highlight.replace(), 'gi'));
    // TODO: refactor this, not a fan of the mutation of part
    for (var i = 0; i < parts.length; i++) {
        if (i !== parts.length - 1) {
            var match = matches[i];
            // While the next part is an empty string, merge the corresponding match with the current
            // match into a single <span/> to avoid consequent spans with nothing between them.
            while (parts[i + 1] === '') {
                match += matches[++i] || '';
            }
            parts[i] = (React.createElement(React.Fragment, { key: i },
                parts[i],
                React.createElement("span", { className: "highlighted" }, match)));
        }
    }
    return React.createElement("span", { className: "highlighter " + className }, parts);
};
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    var baseColor = color || theme.color.primary.background;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      &:hover {\n        .icon-button {\n          display: block;\n        }\n      }\n      .icon-button {\n        display: none;\n        line {\n          stroke: ", ";\n        }\n      }\n    "], ["\n      position: relative;\n      &:hover {\n        .icon-button {\n          display: block;\n        }\n      }\n      .icon-button {\n        display: none;\n        line {\n          stroke: ", ";\n        }\n      }\n    "])), baseColor);
});
var Box = styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    var baseColor = color || theme.color.primary.background;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: #fff;\n      list-style: none;\n      height: auto;\n      max-height: 50vh;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      overflow: auto;\n      overflow: overlay;\n      scroll-behavior: smooth;\n      transition: transform 0.15s;\n      box-shadow: ", ";\n      z-index: 10000;\n      &::-webkit-scrollbar {\n        width: 20px;\n        background-color: rgba(255, 255, 255, 0);\n      }\n\n      ::-webkit-scrollbar-track,\n      ::-webkit-scrollbar-thumb {\n        border: 5px solid rgba(255, 255, 255, 0);\n        background-clip: padding-box;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: transparent;\n        border-radius: 0 2px 2px 0;\n        &:hover {\n          background: ", ";\n        }\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: ", ";\n        border-radius: 500px;\n        margin: 0 2px;\n      }\n      [data-popper-placement^='top'] & {\n        margin-bottom: 10px;\n      }\n      [data-popper-placement^='bottom'] & {\n        margin-top: 5px;\n      }\n      li {\n        height: 50px;\n        padding: ", ";\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n        color: ", ";\n        &.selected {\n          background: ", ";\n        }\n        &:hover {\n          background: ", ";\n          cursor: pointer;\n        }\n        .highlighted {\n          font-weight: bold;\n        }\n        .line2 {\n          font-size: ", ";\n          color: ", ";\n        }\n      }\n    "], ["\n      background: #fff;\n      list-style: none;\n      height: auto;\n      max-height: 50vh;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      overflow: auto;\n      overflow: overlay;\n      scroll-behavior: smooth;\n      transition: transform 0.15s;\n      box-shadow: ", ";\n      z-index: 10000;\n      &::-webkit-scrollbar {\n        width: 20px;\n        background-color: rgba(255, 255, 255, 0);\n      }\n\n      ::-webkit-scrollbar-track,\n      ::-webkit-scrollbar-thumb {\n        border: 5px solid rgba(255, 255, 255, 0);\n        background-clip: padding-box;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: transparent;\n        border-radius: 0 2px 2px 0;\n        &:hover {\n          background: ", ";\n        }\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: ", ";\n        border-radius: 500px;\n        margin: 0 2px;\n      }\n      [data-popper-placement^='top'] & {\n        margin-bottom: 10px;\n      }\n      [data-popper-placement^='bottom'] & {\n        margin-top: 5px;\n      }\n      li {\n        height: 50px;\n        padding: ", ";\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n        color: ", ";\n        &.selected {\n          background: ", ";\n        }\n        &:hover {\n          background: ", ";\n          cursor: pointer;\n        }\n        .highlighted {\n          font-weight: bold;\n        }\n        .line2 {\n          font-size: ", ";\n          color: ", ";\n        }\n      }\n    "])), baseColor, theme.size.radius.small, theme.shadow.elevation.level1, desaturate(0.7, lighten(0.3, baseColor)), baseColor, theme.size.spacer.medium, darken(0.15, baseColor), desaturate(0.5, lighten(0.4, baseColor)), desaturate(0.5, lighten(0.5, baseColor)), theme.font.primary.size.small, darken(0.15, baseColor));
});
var isElementExist = function (items, input) {
    items = items.filter(function (item) { return item.toUpperCase().includes(input.toUpperCase()); });
    return items.length > 0;
};
export function SAAutocomplete(_a) {
    var label = _a.label, hint = _a.hint, options = _a.options, id = _a.id, color = _a.color, className = _a.className, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onBlur = _a.onBlur, onSelect = _a.onSelect, error = _a.error, theme = _a.theme, value = _a.value, fullWidth = _a.fullWidth, resultComponent = _a.resultComponent, rest = __rest(_a, ["label", "hint", "options", "id", "color", "className", "onChange", "onKeyDown", "onFocus", "onBlur", "onSelect", "error", "theme", "value", "fullWidth", "resultComponent"]);
    var filterSuggestions = function (input) {
        return options.filter(function (item) {
            if (!Array.isArray(item) && item != null && typeof item === 'object') {
                return isElementExist(item.label, input);
            }
            var option = Array.isArray(item) ? item[0] : item;
            return option.toUpperCase().includes(input.toUpperCase());
        });
    };
    var initialSuggestions = value ? filterSuggestions(value) : options;
    var _b = useState(initialSuggestions), suggestions = _b[0], setSuggestions = _b[1];
    var _c = useState(0), activeSuggestion = _c[0], setActiveSuggestion = _c[1];
    var _d = useState(value), userInput = _d[0], setUserInput = _d[1];
    var _e = useState(false), dropdownVisible = _e[0], setDropdownVisible = _e[1];
    // refs
    var selectedRef = React.useRef(null);
    // Popper
    var _f = useState(null), referenceElement = _f[0], setReferenceElement = _f[1];
    var _g = useState(null), popperElement = _g[0], setPopperElement = _g[1];
    var modifiers = useMemo(function () { return [
        {
            name: 'sameWidth',
            enabled: true,
            fn: function (_a) {
                var state = _a.state;
                state.styles.popper.width = state.rects.reference.width + "px";
            },
            phase: 'beforeWrite',
            requires: ['computeStyles'],
        },
    ]; }, []);
    var _h = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start',
        modifiers: modifiers,
    }), styles = _h.styles, attributes = _h.attributes;
    function setReactInputValue(element, val) {
        var _a, _b;
        var valueSetter = (_a = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(element, 'value')) === null || _a === void 0 ? void 0 : _a.set;
        var prototype = Object.getPrototypeOf(element);
        var prototypeValueSetter = (_b = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(prototype, 'value')) === null || _b === void 0 ? void 0 : _b.set;
        /* The else case is for IE11 only */
        /* istanbul ignore else */
        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter === null || prototypeValueSetter === void 0 ? void 0 : prototypeValueSetter.call(element, val);
        }
        else {
            valueSetter === null || valueSetter === void 0 ? void 0 : valueSetter.call(element, val);
        }
        // 'change' instead of 'input', see https://github.com/facebook/react/issues/11488#issuecomment-381590324
        var event;
        /* The else case is for IE11 only */
        /* istanbul ignore else */
        if (typeof Event === 'function') {
            event = new Event('change', { bubbles: true });
        }
        else {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
        }
        element.dispatchEvent(event);
    }
    var handleUserInput = function (inputValue) {
        setUserInput(inputValue);
        setSuggestions(filterSuggestions(inputValue));
    };
    var handleChange = function (e) {
        handleUserInput(e.currentTarget.value);
        if (onChange) {
            onChange(e);
        }
    };
    var retrieveSelectionValue = function (selection) {
        if (Array.isArray(selection)) {
            return selection[0];
        }
        if (!Array.isArray(selection) && typeof selection === 'object' && selection != null) {
            return selection.value;
        }
        return selection;
    };
    var handleSelection = function (selection) {
        var selectedItem = retrieveSelectionValue(selection);
        setReactInputValue(referenceElement, selectedItem);
        if (onSelect !== undefined) {
            onSelect(selectedItem);
        }
        setDropdownVisible(false);
    };
    var handleFocus = function (e) {
        setDropdownVisible(true);
        setSuggestions(initialSuggestions);
        if (onFocus !== undefined) {
            onFocus(e);
        }
    };
    var handleBlur = function (e) {
        if (onBlur !== undefined) {
            onBlur(e);
        }
        setDropdownVisible(false);
    };
    var clearInput = function () {
        setReactInputValue(referenceElement, '');
    };
    var handleKeyDown = function (e) {
        setDropdownVisible(true);
        if (onKeyDown !== undefined) {
            onKeyDown(e);
        }
        if (['Up', 'ArrowUp'].includes(e.key)) {
            if (activeSuggestion === 0) {
                setActiveSuggestion(suggestions.length - 1);
                return;
            }
            setActiveSuggestion(activeSuggestion - 1);
        }
        // User pressed the down arrow
        else if (['Down', 'ArrowDown'].includes(e.key)) {
            if (activeSuggestion === suggestions.length - 1) {
                setActiveSuggestion(0);
                return;
            }
            setActiveSuggestion(activeSuggestion + 1);
        }
        else if (e.key === 'Enter') {
            handleSelection(suggestions[activeSuggestion]);
        }
        else if (e.key === 'Tab') {
            handleSelection(userInput);
        }
        else {
            setActiveSuggestion(0);
        }
    };
    useEffect(function () {
        setUserInput(value);
    }, [value]);
    useEffect(function () {
        if (selectedRef.current && popperElement) {
            popperElement.children[0].scrollTop = selectedRef.current.offsetTop;
        }
    }, [activeSuggestion]);
    return (React.createElement(Wrapper, { color: color, theme: theme },
        React.createElement(SAInput, __assign({ id: id, label: label, hint: hint, icon: SAIcons.x, onClickIcon: function () { return clearInput(); }, color: color, error: error, theme: theme, className: className, fullWidth: fullWidth, type: "text", onChange: handleChange, onKeyDown: handleKeyDown, onFocus: function (e) { return handleFocus(e); }, onBlur: function (e) { return handleBlur(e); }, value: userInput, "aria-activedescendant": dropdownVisible ? id + "-option-" + activeSuggestion : undefined, "aria-autocomplete": "list", role: "combobox", "aria-controls": id + "-list", "aria-expanded": dropdownVisible && suggestions.length > 0, ref: setReferenceElement, autoComplete: "off" }, rest)),
        dropdownVisible &&
            suggestions.length > 0 &&
            ReactDOM.createPortal(React.createElement("div", __assign({ ref: setPopperElement, style: __assign(__assign({}, styles.popper), { zIndex: 10000 }) }, attributes.popper),
                React.createElement(Box, { role: "listbox", color: color, id: id + "-list", theme: theme, className: "sa-autocomplete-results-wrapper" }, suggestions.map(function (item, index) {
                    var selected = index === activeSuggestion;
                    if (!Array.isArray(item) && typeof item === 'object' && item != null) {
                        return (React.createElement("li", { onMouseDown: function (event) { return event.preventDefault(); }, onClick: function () { return handleSelection(item); }, onKeyDown: function (e) { return e.key === 'Enter' && handleSelection(item); }, "aria-selected": selected, role: "option", key: item.value, className: selected ? 'selected' : '', id: id + "-option-" + index, ref: selected ? selectedRef : undefined, tabIndex: -1 }, resultComponent ? resultComponent(item.label, userInput) : ''));
                    }
                    return (React.createElement("li", { onMouseDown: function (event) { return event.preventDefault(); }, onClick: function () { return handleSelection(item); }, onKeyDown: function (e) { return e.key === 'Enter' && handleSelection(item); }, "aria-selected": selected, role: "option", key: Array.isArray(item) ? item[0] : item, className: selected ? 'selected' : '', id: id + "-option-" + index, ref: selected ? selectedRef : undefined, tabIndex: -1 },
                        React.createElement(SAHighlighter, { highlight: userInput, className: "line1" }, Array.isArray(item) ? item[0] : item),
                        Array.isArray(item) && React.createElement("span", { className: "line2" }, item[1])));
                }))), document.body)));
}
SAAutocomplete.defaultProps = {
    label: undefined,
    hint: undefined,
    error: false,
    onChange: undefined,
    color: undefined,
    className: undefined,
    onKeyDown: undefined,
    onFocus: undefined,
    onBlur: undefined,
    onSelect: undefined,
    theme: SAUX360Theme,
    value: '',
    fullWidth: false,
    resultComponent: undefined,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=autocomplete.component.js.map